import { Box, FlexBox, IconButton, Tooltip } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { ampli } from 'lib-shared-tracking';
import { PropsWithChildren } from 'lib-shared-types-utils';
import noop from 'lodash/noop';
import { useCallback } from 'react';

import styles from './editorCopilotDropdownContentBox.module.scss';

type ContentBoxProps = PropsWithChildren & {
  isEmphasized?: boolean;
  handleUndo?: () => void;
};

export const EditorCopilotDropdownContentBox = ({
  children,
  isEmphasized,
  handleUndo,
}: ContentBoxProps): JSX.Element => {
  const undoDisabled = handleUndo === undefined;
  const handleUndoOnClick = useCallback(() => {
    ampli.agentCopilotUndoClicked();
    handleUndo?.();
  }, [handleUndo]);

  return (
    <FlexBox
      className={classnames({
        [styles.isEmphasized]: isEmphasized,
      })}
    >
      <FlexBox flex="1 1 auto" alignItems="center">
        <Box className={styles.content} padding="300">
          {children}
        </Box>
      </FlexBox>
      <FlexBox flex="0 1 auto" alignItems="center" padding="300">
        <Tooltip content="Undo last change" disabled={undoDisabled}>
          <IconButton
            icon="undo"
            variant="tertiary"
            onClick={undoDisabled ? noop : handleUndoOnClick}
            disabled={undoDisabled}
          />
        </Tooltip>
      </FlexBox>
    </FlexBox>
  );
};
